<template>
  <div class="survey">
    <div v-if="error" class="color-negative">
      {{ error }}
    </div>

    <template v-if="isDone">
      <Form />
    </template>

    <template v-else>
      <Question
        v-for="question in questions"
        :key="question.id"
        :question="question"
        :is-active="question.id === currentQuestionId"
      />

      <div class="survey__steps">
        <div
          v-for="(question, index) in questions"
          :key="question.id"
          v-text="index + 1"
          :class="['survey__step btn--reset', {
            'is-done': stepIsDone(question.id),
            'is-active': stepIsActive(question.id),
          }]"
        />
      </div>

      <div
        v-if="currentQuestion.text"
        class="survey__text font-size-sm sm-font-size-lg text-center capped-md"
      >
        {{ currentQuestion.text }}
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Form from '@/survey/components/Form.vue';
import Question from '@/survey/components/Question.vue';

export default {
  components: {
    Form,
    Question,
  },

  computed: {
    ...mapGetters([
      'error',
      'isDone',
      'questions',
      'answeredQuestions',
      'currentQuestion',
      'currentQuestionId',
    ]),

    isDone() {
      return this.questions.length === this.answeredQuestions.length;
    },

    stepIsDone() {
      return (id) => this.answeredQuestions.some((item) => item.question_id === id);
    },

    stepIsActive() {
      return (id) => this.currentQuestionId === id;
    },
  },
};
</script>
